import * as React from "react";
import { db } from "../../firebase";
import { Form , Button } from 'semantic-ui-react'
import { WithContext as ReactTags } from 'react-tag-input';
import '../categories/reactTags.css';

interface InterfaceProps {
  error?: any;
  history?: any;
  GifName?: string;
  tags?: any[];
  relatedTags?: any[];
  onGifUpdated: any
  handleCloseModal: any;
  currentGif: any
}

interface InterfaceState {
  error?: any;
  GifName?: string;
  GifDescription?: string;
  relatedTags?: any[];
}

export class GifUpdateForm extends React.Component<
  InterfaceProps,
  InterfaceState
> {
  private static INITIAL_STATE = {
    error: null,
    GifName: "",
    GifDescription: "",
    relatedTags: [],
  };

  private static propKey(propertyName: string, value: string): object {
    return { [propertyName]: value };
  }

  constructor(props: any) {
    super(props);
    this.state = {     
        error: null,
        GifName: this.props.currentGif.title,
        GifDescription: this.props.currentGif.description,
        relatedTags: this.props.currentGif.tags
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }



  public onSubmit = (event: any) => {
    const { GifName, GifDescription, relatedTags }: any = this.state;
    const { currentGif, onGifUpdated } = this.props;


    db.doUpdateGif(currentGif.id, GifName, GifDescription, relatedTags)
      .then(() => {
            currentGif.title = GifName;
            currentGif.description = GifDescription;
            currentGif.tags = relatedTags;
            this.setState(() => ({ ...GifUpdateForm.INITIAL_STATE }));
            onGifUpdated(currentGif)
      })
      .catch(error => {
        this.setState(GifUpdateForm.propKey("error", error));
      }); 
    event.preventDefault();
  };

    handleDelete(i) {   
        const { relatedTags } = this.state;
        this.setState({
         relatedTags: relatedTags.filter((tag, index) => index !== i),
        });
    }
 
 
    handleAddition(tag) {
        this.setState(state => ({ relatedTags: [...state.relatedTags, tag] }));
    }
 
    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.relatedTags];
        const newTags = tags.slice();
 
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
 
        // re-render
        this.setState({ relatedTags: newTags });
    }


  public render() {
    const { GifName,  GifDescription, relatedTags, error }: any = this.state;
    const { tags, handleCloseModal} : any = this.props;
    const tagOptions = Object.keys(tags).map(key => ({ id : key, text: tags[key].text }));
    const isInvalid = GifName === "";
    return (
        <Form  onSubmit={event => this.onSubmit(event)}>
          <Form.Field>
            <label>Name</label>
            <input
              value={GifName}
              onChange={event => this.setStateWithEvent(event, "GifName")}
              type="text"
              placeholder="Gif Name"
            />
          </Form.Field>
          <Form.Field>
            <label>Description</label>
            <input
              value={GifDescription}
              onChange={event => this.setStateWithEvent(event, "GifDescription")}
              type="text"
              placeholder="Gif Description"
            />
          </Form.Field>
          <Form.Field> 
            <label>Related Tags</label>
            <div>
                <ReactTags 
                    placeholder="Add a tag"
                    tags={relatedTags}
                    suggestions={tagOptions}
                    handleDelete={this.handleDelete}
                    handleAddition={this.handleAddition}
                    handleDrag={this.handleDrag}
                />
            </div>
          </Form.Field>
          <Button type='submit' disabled={isInvalid} positive >Save</Button>
          <Button onClick={handleCloseModal} primary>Dismiss</Button>
          {error && <p>{error.message}</p>}
        </Form>
    );
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(
      GifUpdateForm.propKey(columnType, (event.target as any).value)
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/gifs/gifUpdateForm.tsx